import { collection, doc, serverTimestamp, writeBatch } from "firebase/firestore";
import { seasonalHelpers } from "projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers";
import { dispatchProps } from '../../../cnr/reducers/reducerHelpers/dispatchProps';
import { dataFix } from "../../../common/dataFix";
import { createRefPath, createRefPath_event } from "../../appData/appRefPaths";
import { addPromise } from '../../promises/addPromise';
import { updateDocumentHelpers } from "./fsUpdate_document";

export const fsUpdate_addData = async (props) => {

  const {
    baseRef,
    dispatch,
    opts,
    pathViews,
    ufProps,
    database_fns,
    appSettings_fns,
    mainDb,
    relatedDocsToUpdate,
  } = props

  const { refPath, directCollection } = baseRef
  let { vit, itemData, selectedDataItems, viDeps, dataRestrictions, appUser, storagePaths, autoUpdateCollectionRelationships, staticViewKeys, useTimestamps, appDataSource } = ufProps ?? {}
  let { useSubDataCollection, subDataCollectionName } = viDeps ? viDeps : {}

  const { useAppDataDocuments, useAppDataDocumentsOnly, updateAppDataDocuments } = appDataSource ?? {}

  let _updateAppDataDocuments = updateAppDataDocuments || useAppDataDocuments

  const _itemData = dataFix.removeAllEmpties(itemData)
  const pks = seasonalHelpers.getPks(pathViews)

  if (dataRestrictions && (dataRestrictions.all || dataRestrictions.addData)) {
    dispatch({ type: dispatchProps.successAlt, dispatch })
    return false
  }

  if (useSubDataCollection && subDataCollectionName) {
    fsUpdate_subCollection(database_fns, pathViews, pks, vit, _itemData, dispatch)
  } else {

    const callback_add = (results) => {

      if (opts && opts.settingsProps) {
        appSettings_fns.createNewViewAndViewItemsSettingsDB(opts.settingsProps, pathViews).then(
          dispatch && dispatch({ type: dispatchProps.success, dispatch })
        )
      }

      const { dataToUpdate, res } = results ?? {}
      const { id: viewKey } = res ?? {}

      // autoUpdateCollectionRelationships && fsUpdate_updateRelatedCollections(pathViews, vit, null, dataToUpdate, viewKey, staticViewKeys)

      if (_updateAppDataDocuments) {
        updateDocumentHelpers.update_itemInDocuments(null, null, database_fns, pathViews, vit, viewKey, _itemData, null, _updateAppDataDocuments)
      }

      dispatch && dispatch({ ...results, dispatch })
    }

    if (useTimestamps) {
      itemData._ts = { _updateDate: serverTimestamp() }
      if (appUser) {
        itemData._uid = appUser.uid
        itemData._user = appUser.displayName
      }
    }

    if (_itemData && (!selectedDataItems || Object.keys(selectedDataItems).length === 0)) {
      switch (vit) {
        default:

          const batchInfos = []
          const batch = writeBatch(mainDb);

          // primary doc
          const _addRef = createRefPath([vit], refPath)
          const collection_primary = collection(mainDb, _addRef);
          const primaryRef = doc(collection_primary);   // <-- auto-id generated here
          const docId = primaryRef.id;             // <-- THIS is the key you need

          // const doc_primary = doc(mainDb, _addRef)
          batch.set(primaryRef, _itemData);
          batchInfos.push({ refPath: primaryRef.path, _itemData })

          // _document doc
          const baseRef = createRefPath_event(pathViews)
          const _refPathDoc = createRefPath(['_documents', vit], baseRef)
          const doc_docs = doc(mainDb, _refPathDoc)
          const docToUpdate = { [docId]: _itemData }
          batch.set(doc_docs, docToUpdate, { merge: true });
          // batch.set(doc_docs, _itemData, { merge: true })
          batchInfos.push({ refPath: _refPathDoc, dataToUpdate: docToUpdate })

          const ref_path_ts = createRefPath(['_timeStamps', 'eventInfo'])
          const doc_ts = doc(mainDb, ref_path_ts)
          const tsToUpdate = {
            [pathViews.events]: Date.now()
          }
          batch.set(doc_ts, tsToUpdate, { merge: true })
          batchInfos.push({ refPath: ref_path_ts, dataToUpdate: tsToUpdate })

          console.log('batchInfos', batchInfos)
          await batch.commit()

          dispatch && dispatch({ type: dispatchProps.success, dispatch })
      }
    } else {
      if (selectedDataItems) {
        if (!useAppDataDocumentsOnly) {
          addPromise(database_fns, refPath, vit, directCollection, selectedDataItems).then((newItem) => {
            callback_add({ type: dispatchProps.success, addPath: refPath, newItem })
            // if (opts && opts.settingsProps) {
            //   createNewViewAndViewItemsSettingsDB(opts.settingsProps, pathViews).then(
            //     dispatch({ type: dispatchProps.success, dispatch })
            //   )
            // } else {
            //   callback_add({ type: dispatchProps.success, addPath: refPath })
            //   // dispatch({ type: dispatchProps.success, dispatch })
            // }
          }).catch(error => {
            console.log('addData', error)
            dispatch({ type: dispatchProps.error, error, dispatch })
          })
        } else {
          if (_updateAppDataDocuments) {
            const docKey = database_fns.get_docKey()
            updateDocumentHelpers.update_itemInDocuments(null, null, database_fns, pathViews, vit, docKey, _itemData, dispatch, _updateAppDataDocuments)
          }
        }

      }
    }
  }
}

